import type { ClientViewRenderProps } from "./ClientViewRender.tsx";
import { Descriptions } from "antd";
import { Card } from "../../../common/components/Card.tsx";
import { NoData } from "../../../common/components/NoDataComp.tsx";

export const ClientInfo = (props: ClientViewRenderProps) => {
  const { intl, clientData } = props;
  const { client } = clientData;

  return (
    <Card title={intl.formatMessage({ id: "detailed_information" })}>
      <Descriptions bordered column={2}>
        <Descriptions.Item
          label={intl.formatMessage({ id: "client_legal_name" })}
          span={2}
        >
          {client.legal_name}
        </Descriptions.Item>
        <Descriptions.Item label={intl.formatMessage({ id: "client_tax_id" })}>
          {client.tax_id}
        </Descriptions.Item>
        <Descriptions.Item label={intl.formatMessage({ id: "client_billing_address" })}>
          {client.billing_address ?? <NoData intl={intl} />}
        </Descriptions.Item>
        <Descriptions.Item label={intl.formatMessage({ id: "client_contact_name" })}>
          {client.contact_name ?? <NoData intl={intl} />}
        </Descriptions.Item>
        <Descriptions.Item label={intl.formatMessage({ id: "client_contact_email" })}>
          {client.contact_email ?? <NoData intl={intl} />}
        </Descriptions.Item>
        <Descriptions.Item label={intl.formatMessage({ id: "client_contact_phone" })}>
          {client.contact_phone ?? <NoData intl={intl} />}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};
